import { useQueryClient } from '@tanstack/react-query';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
import { settleDismissals } from '~/utils/revenueOpportunities/opportunityDismissals';
import { revenueOpportunitiesSummaryKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useDismissRevenueOpportunity = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutationState({
        mutationFn: async (param)=>{
            let { requests, businessId } = param;
            const settled = settleDismissals(await Promise.allSettled(requests.map((request)=>api.pulse.createDismissal(request))));
            if (settled.dismissedCount > 0) {
                await queryClient.invalidateQueries({
                    queryKey: revenueOpportunitiesSummaryKey(businessId)
                });
            }
            return settled;
        }
    });
    return {
        dismissRevenueOpportunity: mutateAsync
    };
};
